import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/privacy-policy.md?raw';

export default function PrivacyPolicyScreen() {
  return <LegalDoc markdown={markdown} title="Privacy Policy" />;
}
